<template>
  <div>
    <b-modal
      id="add-action-modal"
      ref="add-action-modal"
      size="md"
      @hidden="cancel"
      :title="$t('modals.addAction.text')"
    >
      <!-- Name -->
      <div class="row">
        <div class="col-12 col-lg-12">
          <label for="name">{{$t("modals.name.text")}}</label>
          <b-form-input
            id="name"
            v-model="actionAdd.name"
            class="mb-1"
            :placeholder="$t('modals.name.text')"
            :state="err.name ? false : null"
          ></b-form-input>
          <b-form-invalid-feedback>
            {{ err.name }}
          </b-form-invalid-feedback>
        </div>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <div class="row p-2">
          <div class="col-10 text-right p-1">
            <b-button variant="success" class="text-white" @click="add(ok)">
              {{$t("buttons.add.text")}}
            </b-button>
          </div>
          <div class="col-2 text-center p-1">
            <b-button @click="cancel()"> {{$t("buttons.cancel.text")}} </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {

  created() {},
  data() {
    return {
      actionAdd: {
        name: null,
      },
      err: {
        name: null,
      },
    };
  },
  watch: {
    
  },
  methods: {
    cancel() {
      this.clear();
    },
    clear() {
      this.actionAdd = {
        name: null,
      };
      this.err = {
        name: null,
      };
    },
    add(ok) {
      if (!this.actionAdd.name) this.err.name = this.$t("msgError.obligField.text");
      else this.err.name = "";

      if (!this.err.name) {
        ok();
        this.$emit("addAction", this.actionAdd);
      }
    },
  },
};
</script>